module.exports = __webpack_public_path__ + "static/media/2.394aab0f.JPG";